import { Card, CardBody } from "@progress/kendo-react-layout";
import React, { useEffect, useRef, useState } from "react";
import { CustomRowRender } from "ui/grid/CustomGrid";
import style from "./style.module.css";
import styles from "styles.module.css";
import { ICON_NAMES } from "utils/constant";
import { SalesNoteFrontGridColumnItem } from "component/pages/salesNote/utils/GridColumns";
import { getSalesNotesApi } from "api/salesNote";
import { SalesNote } from "interface/salesNote";
import { addMonths } from "date-fns";
import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import { TextButton } from "ui/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { PageTypePath } from "utils/pages";
import { lastColWithBtn } from "ui/grid/lastColumnts";
import { useHomePageAccessStore, useUserOrganizationsStore } from "store";
import { Loading } from "ui/Loading";
import { GrideDateFormatter } from "ui/Date";

const statusColor = (status: number, signStatus?: number) => {
	if (status === 1) return "#D64545";
	if (status === 2) return "#e6bf00";
	if (status === 4 && signStatus === 0) return "#f28c28";
	return "#2b8e61";
};

function SalesNoteCard({ isMobileView = false }: { isMobileView?: boolean }) {
	const { t } = useTranslation();
	const [gridData, setGridData] = useState<SalesNote[]>();

	const router = useNavigate();

	const { defaultOrg } = useUserOrganizationsStore();
	const { homePageAccess } = useHomePageAccessStore();
	useEffect(() => {
		if (!homePageAccess?.salesNote || !homePageAccess.salesNote.read) return;

		getSalesNotesApi({
			take: 3,
			skip: 0,
			//buyerId: defaultOrg?.ledgerAccountNumber as any,
			vesselHullId: defaultOrg?.vesselId as any,
			fromDate: addMonths(new Date(), -12),
			toDate: new Date(),
		})
			.then((response) => {
				setGridData(response.data);
			})
			.catch((err) => {
				console.log(err);
			});
	}, [defaultOrg, homePageAccess?.salesNote]);

	const openEditPage = (props: GridCellProps) => {
		if (props.dataItem.noteStatusId === 4) {
			router(`/${PageTypePath.Signature}/${props.dataItem.noteNumber}`, {
				state: {
					noteType: 0, // 0  for sales note 1 for landing note
					quotaTypeCode: props.dataItem.quotaTypeCode,
				},
			});
			return;
		}
		router(`/${PageTypePath.SalesNoteForm}/${props.dataItem.noteNumber}`);
	};

	const previewPage = (props: GridCellProps) => {
		const step = 3;
		router(
			`/${PageTypePath.SalesNoteForm}/${props.dataItem.noteNumber}/${step}`,
		);
	};

	const pageAccess = homePageAccess?.salesNote;
	if (!pageAccess) {
		return <Loading show={true} />;
	}
	const openPdf = (prop: GridCellProps) => {
		window.open(`/${PageTypePath.Pdf}/${prop.dataItem.reportGuid}`, "_blank");
	};

	return (
		<div>
			<Card //className={style.CardItem}
				className={"home-card-item"}
			>
				<CardBody>
					<div className={`${styles.BoxHeadingMedium} ${style.CardBodyHeader}`}>
						<div>{t("LastSalesNotes")}</div>
						<div>
							<TextButton
								text={t("OverViewSalesNotes")}
								onClick={() => router(`/${PageTypePath.SalesNotesList}`)}
								iconName={ICON_NAMES.Arrow}
							/>
						</div>
					</div>
					<div>
						{isMobileView ? (
							<div>
								{(gridData || []).map((item, index) => {
									const showEdit = pageAccess?.update && item.source === 0;
									const showSignature =
										pageAccess?.update && item.noteStatusId === 4;

									return (
										<div
											key={`${item.noteNumber}-${index}`}
											className="home-mobile-list-item"
										>
											<div
												style={{
													width: 10,
													height: 10,
													borderRadius: "50%",
													backgroundColor: statusColor(
														item.noteStatusId,
														item.signStatus,
													),
												}}
											/>
											<div className="home-mobile-list-item-main">
												<div className="home-mobile-list-item-value">
													{item.noteNumber}
												</div>
												<div className="home-mobile-list-item-label">
													<GrideDateFormatter
														date={item.landingTime}
														formatType="dd.MM.yyyy"
														noTd={true}
													/>
												</div>
											</div>
											<div className="home-mobile-list-item-secondary">
												{item.amount || 0} kr
											</div>
											<div className="home-mobile-list-item-actions">
												{(showEdit || showSignature) && (
													<button
														type="button"
														className="home-mobile-icon-btn"
														onClick={() =>
															openEditPage({ dataItem: item } as GridCellProps)
														}
													>
														<img
															src={`/icon/${
																showSignature
																	? ICON_NAMES.Signature
																	: ICON_NAMES.Edit
															}.svg`}
															alt={showSignature ? t("Signature") : t("Edit")}
														/>
													</button>
												)}
												{pageAccess?.update && item.source === 0 && (
													<button
														type="button"
														className="home-mobile-icon-btn"
														onClick={() =>
															previewPage({ dataItem: item } as GridCellProps)
														}
													>
														<img
															src={`/icon/${ICON_NAMES.Checkbox}.svg`}
															alt={t("Preview")}
														/>
													</button>
												)}
												<button
													type="button"
													className="home-mobile-icon-btn"
													onClick={() =>
														openPdf({ dataItem: item } as GridCellProps)
													}
												>
													<img
														src={`/icon/${ICON_NAMES.Download}.svg`}
														alt={t("Download")}
													/>
												</button>
											</div>
										</div>
									);
								})}
							</div>
						) : (
							<Grid
								style={{ height: "auto" }}
								rowHeight={38}
								rows={{ data: (row) => CustomRowRender(row) }}
								data={gridData}
								className={
									styles.tableColgroupColFirstChild + " custom_detail_grid"
								}
							>
								{SalesNoteFrontGridColumnItem().map((column, key) => (
									<GridColumn key={key} {...column} className="no-border" />
								))}
								<GridColumn
										{...lastColWithBtn({
											width: "150px",
											showDetails: false,
											items: [
												...(pageAccess?.update
													? [
														{
															iconName: ICON_NAMES.Edit,
															title: t("EditNote"),
															onclick: openEditPage,
															showConditionValue: 0,
															conditionField: "source",
														},
														{
															iconName: ICON_NAMES.Signature,
															title: t("SignNote"),
															onclick: openEditPage,
															showConditionValue: 4,
															conditionField: "noteStatusId",
														},
														{
															iconName: ICON_NAMES.Checkbox,
															onclick: previewPage,
															showConditionValue: 0,
															conditionField: "source",
														},
														{
															iconName: ICON_NAMES.Download,
															title: t("DownloadPdf"),
															alwaysShow: true,
															onclick: openPdf,
														},
													]
													: [
														{
															iconName: ICON_NAMES.Download,
															alwaysShow: true,
															onclick: openPdf,
														},
													]),
											],
											showDelete: false,
										})}
								/>
							</Grid>
						)}
					</div>
				</CardBody>
			</Card>
		</div>
	);
}

export default SalesNoteCard;
